<wb-navbar [showDeposits]="true" [showCredits]="true"></wb-navbar>
<app-snackbar></app-snackbar>
<router-outlet></router-outlet>

<div class="notifications-fab-button" *ngIf="hasNotificationsBtn$ | async">
  <app-fab-button
    (mainBtnClick)="onMainFabBtnClick()"
    [badgeValue]="notificationsCount$ | async"
  ></app-fab-button>
</div>
